<app-loader [Parent]="this"></app-loader>

@if (Model != null) {
  <div>
    <app-pageheader [Parent]="this">
      <form-edit-button>Edit</form-edit-button>
      <app-form-delete-button [Model]="Model" [Parent]="this" DeleteUrl="integrations/parkchirp/configurations/"
        [DeleteCheck]="false"
        DeleteNavLink="/integrations/parkchirp">
      </app-form-delete-button>
    </app-pageheader>
    <div class="columns is-justify-content-center">
      <div class="column is-8">
        <article class="panel">
          <p class="panel-heading">
            {{Model.Name || 'ParkChirp Configuration'}}
          </p>
          <a class="panel-block">
            <span class="label">URL</span>
            <span class="value">{{Model.Url}}</span>
          </a>
          @if (Model.Description) {
            <a class="panel-block">
              <span class="label">Description</span>
              <span class="value">{{Model.Description}}</span>
            </a>
          }
          <a class="panel-block">
            <span class="label">Username</span>
            <span class="value">{{Model.Username}}</span>
          </a>
          <a class="panel-block">
            <span class="label">Standard Parking Permit Type</span>
            <span class="value">{{StandardPermitTypeName || Model.StandardParkingPermitTypeId}}</span>
          </a>
          <a class="panel-block">
            <span class="label">Reservation Parking Permit Type</span>
            <span class="value">{{ReservationPermitTypeName || Model.ReservationParkingPermitTypeId}}</span>
          </a>
          @if (Model.StandardInitialPermitState != null) {
            <a class="panel-block">
              <span class="label">Standard Initial Permit State</span>
              <span class="value">{{StandardInitialStateName || Model.StandardInitialPermitState}}</span>
            </a>
          }
          @if (Model.ReservationInitialPermitState != null) {
            <a class="panel-block">
              <span class="label">Reservation Initial Permit State</span>
              <span class="value">{{ReservationInitialStateName || Model.ReservationInitialPermitState}}</span>
            </a>
          }
        </article>
      </div>
    </div>
  </div>
}